import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLABORATOR_I18N_KEY } from "./constants";
var es = /*#__PURE__*/_defineProperty({}, COLLABORATOR_I18N_KEY, {
  KH_CLOSE: 'Cerrar',
  KH_LAST_UPDATED: 'Actualizado el: {{date}}',
  KH_MODULES: 'Módulos',
  KH_RATING: 'Valoración',
  KH_STUDENTS: 'Estudiantes',
  KH_COURSE_SEE_DETAIL: 'Ver detalle',
  KH_SEE_CATALOG: 'Ver catálogo',
  KH_COURSE_ENROLL: 'Inscribirse',
  KH_SEARCH: 'Buscar',
  KH_FILTER_CATEGORY_ALL: 'Todos',
  KH_SEARCH_SUCCESS_RESULTS: 'Resultados de tu búsqueda',
  KH_SEARCH_NO_RESULTS: 'No se encontraron resultados',
  KH_SEARCH_X_RESULTS: '{{count}} resultado',
  KH_SEARCH_X_RESULTS_plural: '{{count}} resultados',
  KH_SEARCH_NO_RESULTS_FOR: 'No se encontraron resultados para "{{query}}"',
  KH_SEARCH_NO_RESULTS_ACTION: 'Intenta con otra palabra',
  KH_SEARCH_PLACEHOLDER: '¿Qué deseas buscar?',
  KH_SEARCH_PLACEHOLDER_SHORT: '¿Qué buscas?',
  KH_SEARCH_CLEAR: 'Limpiar búsqueda',
  KH_FILTER_TITLE: 'Filtros',
  KH_FILTER_CTA: 'Filtrar',
  KH_FILTER_ITEM_CATEGORIES: 'Categorías',
  KH_FILTER_ITEM_PROVIDER: 'Proveedor',
  KH_FILTER_ITEM_LEVELS: 'Niveles',
  KH_FILTER_ITEM_LANGUAGES: 'Idiomas',
  KH_FILTER_ITEM_CONTENT_TYPES: 'Tipo de contenido',
  KH_FILTER_INITIAL_CTA: 'Filtrar por',
  KH_FILTER_VIEW_ALL: 'Ver todos',
  KH_COURSES: 'Cursos',
  KH_COURSE: 'Curso',
  KN_DOCUMENT: 'Documento',
  KN_DOWNLOAD: 'Descargar',
  KH_BREADCRUMB_HOME: 'Inicio',
  KH_BREADCRUMB_CATALOG: 'Catálogo',
  KH_BREADCRUMB_INTEREST_CONTENT: 'Contenido de tu interés',
  KH_BREADCRUMB_ONLY: 'Contenido de {{name}}',
  KH_BREADCRUMB_THIRD_PARTY_CONTENT: 'Contenidos externos',
  KH_COME_BACK: 'Atrás',
  KH_ERROR_VIEW_MESSAGE: 'Ups! Algo salió mal. Por favor, recarga la página. Si el problema persiste, contacta con soporte.',
  KH_ERROR_VIEW_SHOW_ERROR: 'Mostrar error',
  KH_ERROR_VIEW_HIDE_ERROR: 'Ocultar error',
  KH_ERROR_VIEW_TRY_AGAIN: 'Recargar página',
  KH_NO_DATA_LOADED_ERROR_MESSAGE: 'Lo sentimos, no se han encontrado categorías o cursos disponibles. Esto puede deberse a que las categorías no han sido cargadas correctamente o que no contienen cursos. Por favor, contacta con el administrador de la plataforma para solucionar el problema.',
  KH_CONTENT_OF_INTEREST_TITLE: 'Contenido de tu interés',
  KH_THIRD_PARTY_CONTENT_TITLE: 'Contenidos externos',
  KH_COURSES_DYNAMIC: '{{count}} curso',
  KH_COURSES_DYNAMIC_plural: '{{count}} cursos',
  KH_TEXT_TRACK: 'Ruta'
});
export default es;